import {
    MDBDatatable,
    MDBDropdown,
    MDBDropdownItem,
    MDBDropdownMenu,
    MDBDropdownToggle,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import React, {useEffect, useState} from 'react';
import {format, parseISO} from 'date-fns';
import {CSVLink} from 'react-csv';
import {dateHelpers} from '../../../helper/dates';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const convertISOToReadableTimeFormat = (date) => {
    return format(parseISO(date), "MM/dd/yy");
};

const tableHeading = [
    {label: 'Date', field: 'Date'},
    {label: 'Action', field: 'Action'}
];

const formatRowStructureForExport = (billActions) => {
    return billActions.map((item) => {
        return {
            "Date": convertISOToReadableTimeFormat(item?.date),
            "Action": item?.actionType?.description ? item.actionType.description.replace("Print Version Ready", "") : ''
        };
    }).filter(item => item.Action.startsWith("(C)"));
};

const formatRowStructureForArchiveStatusDatatable = ({floorVoteSheetLinks, voteSheetLinks, billActions}) => {
    return billActions.reduce((formattedRows, item) => {
        const actionDescription = item?.actionType?.description || '';
        const filteredDescription = actionDescription.replace("Print Version Ready", "").trim();
        if (filteredDescription.startsWith("(C)")) {
            formattedRows.push({
                "Date": convertISOToReadableTimeFormat(item?.date),
                "Action": filteredDescription
            });
        }
        return formattedRows;
    }, []);
};

const formatRowStructureForLawsStatusDatatable = ({billActions}) => {
    return billActions.reduce((formattedRows, item) => {
        formattedRows.push({
            "Date": convertISOToReadableTimeFormat(item?.timeStamp),
            "Action": item?.billStatusCode?.name || ''
        });
        return formattedRows;
    }, []);
};

const exportData = (data, fileName, format) => {
    if (format === 'csv') {
        return (
            <CSVLink className='csv-link' id="csvLink" data={data} filename={`${fileName}.csv`}>Excel/CSV</CSVLink>
        );
    } else if (format === 'pdf') {
        const doc = new jsPDF();
        doc.text('Exported Data', 10, 10);
        const headers = Object.keys(data[0]);
        const tableData = data.map(row => headers.map(header => row[header]));
        doc.autoTable({head: [headers], body: tableData});
        doc.save(`${fileName}.pdf`);
        return null;
    } else if (format === 'print') {
        window.print();
    } else {
        console.error('Unsupported export format');
        return null;
    }
};

const Status = ({active, bill, ordinal, onLoad, onError}) => {
    const [formattedData, setFormattedData] = useState({columns: tableHeading, rows: []});
    const [tableClick, setTableClick] = useState(false);

    useEffect(() => {

        async function processBillActions() {
            let formattedRow = [];

            if (bill.hasOwnProperty('sessionId')) {
                formattedRow = formatRowStructureForLawsStatusDatatable({
                    floorVoteSheetLinks: null,
                    voteSheetLinks: null,
                    billActions: bill.draft.billStatuses
                });
            } else {
                const processedActions = bill.billActions.map(billAction => {
                    return {...billAction, media: false};
                });
                formattedRow = formatRowStructureForArchiveStatusDatatable({
                    floorVoteSheetLinks: null,
                    voteSheetLinks: null,
                    billActions: processedActions
                });
            }
            setFormattedData({columns: tableHeading, rows: formattedRow});
        }

        async function fetchDataAndProcess() {
            //const mediaLinks = await fetchBillMediaLinks();
            processBillActions();
        }

        fetchDataAndProcess();
        onLoad();
    }, [bill.draft]);

    const handleCsvClick = () => {
        const link = document.getElementById('csvLink');
        link.click();
    };

    return (
        <MDBTabsPane show={active}>
            <div className="accordion-body">
                <div className='row pb-3 g-0'>
                    <div className='col-sm align-items-center text-center text-md-start mb-3 mb-md-0'>
                        <div className="form-check form-check-inline">
                        </div>
                    </div>
                    <div className='col-sm align-items-center'>
                        {/* <input
                            style={{ width: '100%' }}
                            className='form-control'
                            placeholder='Search Status...'
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        /> */}
                    </div>
                    <div className='col-auto mt-sm-0 mx-auto mt-3'>
                        <div className='d-flex justify-content-end p-0'>
                            <MDBDropdown>
                                <MDBDropdownToggle className='shadow-none ms-1'><i
                                    className="fa-light fa-cloud-arrow-down"
                                    aria-hidden="true"></i> Export</MDBDropdownToggle>
                                <MDBDropdownMenu>
                                    <MDBDropdownItem link onClick={(e) => {
                                        e.preventDefault();
                                        handleCsvClick()
                                    }}>{exportData(formattedData.rows, `Status_details_${dateHelpers.getCurrentDate()}`, 'csv')}</MDBDropdownItem>
                                    <MDBDropdownItem link onClick={(e) => {
                                        e.preventDefault();
                                        exportData(formatRowStructureForExport(bill.billActions), `Status_details_${dateHelpers.getCurrentDate()}`, 'pdf')
                                    }}>PDF/Print</MDBDropdownItem>
                                </MDBDropdownMenu>
                            </MDBDropdown>
                        </div>
                    </div>
                </div>
                <div id="table-actions_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                    <div className='row'>
                        <MDBDatatable
                            data={formattedData}
                            fixedHeader={true}
                            bordered
                            pagination={false}
                            entries={1000}
                            className='status-datatable'
                            onClick={() => {
                                setTableClick(!tableClick)
                            }}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-5">
                            <div className="dataTables_info" id="table-actions_info" role="status" aria-live="polite">
                                <small>Showing 1 to {formattedData.rows.length} of {formattedData.rows.length} entries</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MDBTabsPane>
    );
};

export default Status;
